import {takeLatest} from 'redux-saga/effects';
import SearchHandler from '../handlers/searchhandler';

import {fetchTheSearchDataStart} from '../reducers/search';
export default function* watcherSaga() {
  yield takeLatest(fetchTheSearchDataStart.type, SearchHandler);
}
